function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBesttigung = function SvgIconBesttigung(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-134 -147.463)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(134 147.463)",
    style: {
      fill: "none"
    },
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(142 154.463)",
    style: {
      fill: "#f7f7f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.6 30.635 9.987 9.987L45.21 20l-5.271 5.271",
    transform: "translate(143.9 156.571)",
    style: {
      stroke: "#19aa2c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 3,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.465,
    cy: 27.465,
    r: 27.465,
    transform: "translate(146.5 158.963)",
    style: {
      stroke: "#19aa2c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 3,
      fill: "none"
    }
  })));
};
export default SvgIconBesttigung;